import React from "react";
import StrokeStar from "./../../images/icons/stroke_star.svg";
import QuarterStar from "./../../images/icons/quarter_star.svg";
import HalfStar from "./../../images/icons/half_star.svg";
import AlmostStar from "./../../images/icons/almost_full_star.svg";
import FullStar from "./../../images/icons/full_star.svg";

interface StarsProps {
    className?: string;
    width?: string;
    height?: string;
    rating: number;
    useNewDesign?: boolean;
}

const starColor = "#F7941C";
const bgColor = "#DEDEDE";
const strokeColor = "#D19C34";

const Stars: React.FC<StarsProps> = ({
    rating,
    className = "",
    width = "84",
    height = "21",
    useNewDesign = false,
}) => {
    const numWidth = parseInt(width);
    const numHeight = parseInt(height);
    const squareSize = numWidth / 5;

    const getRoundedRating = (rating: number) => {
        return Math.round(rating * 4) / 4;
    };
    const roundedRating = getRoundedRating(rating);

    const renderStar = () => (
        <svg
            viewBox="0 0 24 24"
            width="80%"
            height="80%"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon
                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                fill="white"
            />
        </svg>
    );

    const getStarType = (starFill: number) => {
        if (starFill >= 0.875) return FullStar;
        if (starFill >= 0.625) return AlmostStar;
        if (starFill >= 0.375) return HalfStar;
        if (starFill >= 0.125) return QuarterStar;
        return StrokeStar;
    };

    if (useNewDesign) {
        // New design rendering
        const squares = Array.from({ length: 5 }, (_, index) => {
            const isPartialFill = rating > index && rating < index + 1;
            return (
                <div
                    key={index}
                    className="relative inline-block"
                    style={{
                        width: `${squareSize}px`,
                        height: `${numHeight}px`,
                        margin: "1px",
                        backgroundColor: isPartialFill ? bgColor : (rating > index ? starColor : bgColor),
                        borderRadius: '3px',
                        overflow: 'hidden',
                    }}
                >
                    {isPartialFill && (
                        <div
                            className="absolute top-0 left-0 h-full"
                            style={{
                                width: `${(rating - index) * 100}%`,
                                backgroundColor: starColor,
                                zIndex: 1,
                            }}
                        />
                    )}
                    <div className="flex items-center justify-center w-full h-full inset-0 z-10 relative">
                        {renderStar()}
                    </div>
                </div>
            );
        });

        return <div className={`${className} flex items-center`}>{squares}</div>;
    } else {
        const stars = Array.from({ length: 5 }, (_, index) => {
            const starFill = Math.min((rating - index) * 1, 1);
            return (
                <img
                    key={index}
                    className="relative inline-block"
                    style={{
                        width: `${squareSize}px`,
                        height: `${numHeight}px`,
                    }}
                    src={getStarType(starFill)}
                >
                </img>
            );
        });

        return <div className={`${className} flex items-center`}>{stars}</div>;
    }
};

export default Stars;